import { ListColumn, ListDataColumn } from "../ListColumn";
import { MedicinalProductsListView } from "./MedicinalProductsListView";

export class AbstractCompositionsEntityListView extends MedicinalProductsListView {

        constructor(items: any) {

            const itemFinderArrayColumns=[
                new ListColumn("Num", ListDataColumn.TEXT, "num"),
                new ListColumn("Scientific Name", ListDataColumn.TEXT, "scientificname"),
                new ListColumn("Scientific Code", ListDataColumn.TEXT, "scientificcode"),
                new ListColumn("Substance Type", ListDataColumn.LOOKUP,'is_development','substancestypes'),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME,'validated'),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME,'stamp_nullif')
            ];

            const itemFinderTreeColumns=[
                new ListColumn("Scientific Name", ListDataColumn.TEXT, "scientificname"),
                new ListColumn("Scientific Code", ListDataColumn.TEXT, "scientificcode"),
                new ListColumn("Scientific Strength", ListDataColumn.TEXT,'scientificstrength'),
                new ListColumn("Scientific Pharmaceutical Form Name", ListDataColumn.TEXT,'name_pharmform'),
                new ListColumn("Substance Type", ListDataColumn.LOOKUP,'is_development','substancestypes'),
                new ListColumn("Status", ListDataColumn.LOOKUP,'status','pispStatus'),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME,'validated'),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME,'stamp_nullif')
            ];

            super(items,itemFinderArrayColumns,itemFinderTreeColumns);


    }

}